import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Api from "./services/Api";
import WebConstant from "./WebConstant";
import { isValidUrl } from "./utility/IamLoginUtils";
import DOMPurify from "dompurify";

const LoginCSR = () => {
  //const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  console.log("searchParams", searchParams);
  //const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    const fetchUrl = async () => {
      //get query parameter from url for  signOnPolicy
      const urlParams = new URLSearchParams(window.location.search);
      let authRequest = { signOnPolicy: "CSR" };

      let appId =
        urlParams.get(WebConstant.SSO_APP_ID) ||
        urlParams.get(WebConstant.SSO_APPLICATION_ID);
      if (!appId || !/^\d+$/.test(appId)) {
        appId = WebConstant.CSR_DEFAULT_APPID;
      }
      sessionStorage.setItem(WebConstant.SSO_APP_ID, appId);

      const durl =
        urlParams.get(WebConstant.DURL) ||
        urlParams.get(WebConstant.DESTINATION_PAGE);
      if (durl) {
        let isValid = isValidUrl(durl);
        if (isValid) {
          sessionStorage.setItem(WebConstant.DURL, durl);
        } else {
          sessionStorage.removeItem(WebConstant.DURL);
        }
      }

      let result = await Api.getOktaLoginURL(authRequest);
      console.log("result", result);
      console.log("result.authURL", result.authUrl);
      if (result) {
        if (result.nonce) {
          sessionStorage.setItem(WebConstant.NONCE, result.nonce);
        }
        window.location.href = result.authUrl;
      } else {
        //setLoading(false);
      }
    };

    fetchUrl();
  }, []);

  // Render a loading state while the token exchange happens
  /* return (
    <div>{loading ? <h2>Processing authentication...</h2> : <div></div>}</div>
  ); */
  return null;
};
export default LoginCSR;
